import {
  SIMPLE_FILES_FILTER,
  SIMPLE_FILES_FILTER_SUCCESS,
  SIMPLE_FILES_FILTER_ERROR,
  SIMPLE_FILES_SEGMENTS,
  SIMPLE_FILES_SEGMENTS_SUCCESS,
  SIMPLE_FILES_SEGMENTS_ERROR,
  SIMPLE_FILES_LIST,
  SIMPLE_FILES_LIST_SUCCESS,
  SIMPLE_FILES_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  sections: [],
  years: [],
  months: [],
  loadingFilter: false,
  errorFilter: "",
  segments: [],
  loadingSegments: false,
  errorSegments: "",
  files: [],
  loadingList: false,
  errorList: "",
}

const SimpleFiles = (state = initialState, action) => {
  switch (action.type) {
    case SIMPLE_FILES_FILTER:
      state = {
        ...state,
        sections: [],
        years: [],
        months: [],
        loadingFilter: true,
        errorFilter: "",
        segments: [],
        files: [],
      }
      break
    case SIMPLE_FILES_FILTER_SUCCESS:
      state = {
        ...state,
        sections: action.payload.data.response.sections,
        years: action.payload.data.response.years,
        months: action.payload.data.response.months,
        loadingFilter: false,
      }
      break
    case SIMPLE_FILES_FILTER_ERROR:
      state = {
        ...state,
        loadingFilter: false,
        errorFilter: action.payload,
      }
      break
    case SIMPLE_FILES_SEGMENTS:
      state = {
        ...state,
        segments: [],
        loadingSegments: true,
        errorSegments: "",
      }
      break
    case SIMPLE_FILES_SEGMENTS_SUCCESS:
      state = {
        ...state,
        segments: action.payload.data.response.segments,
        loadingSegments: false,
      }
      break
    case SIMPLE_FILES_SEGMENTS_ERROR:
      state = {
        ...state,
        loadingSegments: false,
        errorSegments: action.payload,
      }
      break
    case SIMPLE_FILES_LIST:
      state = {
        ...state,
        files: [],
        loadingList: true,
        errorList: "",
      }
      break
    case SIMPLE_FILES_LIST_SUCCESS:
      state = {
        ...state,
        files: action.payload.data.response,
        loadingList: false,
      }
      break
    case SIMPLE_FILES_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default SimpleFiles
